export default __webpack_public_path__ + "static/media/This is what I'm overly competitive about.ff3f372a.mp4";